import { Box, IconButton, useMediaQuery, useTheme } from '@mui/material'
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined'
import { useEffect, useState } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import authUtils from '../../utils/authUtils'
import Loading from '../common/Loading'
import Sidebar from '../common/Sidebar'
import Brand from '../common/Brand'
import { setUser } from '../../redux/features/userSlice'
import { useToast } from '../common/ToastProvider'

const AppLayout = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const toast = useToast()
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))
  const [loading, setLoading] = useState(true)
  const [mobileOpen, setMobileOpen] = useState(false)

  useEffect(() => {
    let active = true
    authUtils.isAuthenticated().then((user) => {
      if (!active) return
      if (!user) {
        navigate('/login', { replace: true })
        return
      }
      dispatch(setUser(user))
      setLoading(false)
    })
    return () => { active = false }
  }, [navigate, dispatch])

  useEffect(() => {
    const onExpired = () => {
      toast.error('Your session expired. Please log in again.')
      navigate('/login', { replace: true })
    }
    window.addEventListener('auth:expired', onExpired)
    return () => window.removeEventListener('auth:expired', onExpired)
  }, [navigate, toast])

  useEffect(() => {
    if (isDesktop) setMobileOpen(false)
  }, [isDesktop])

  if (loading) return <Loading fullHeight />

  return (
    <Box sx={{ display: 'flex', height: '100dvh', overflow: 'hidden' }}>
      <Sidebar mobileOpen={mobileOpen} onClose={() => setMobileOpen(false)} isDesktop={isDesktop} />

      <Box sx={{ flexGrow: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
        <Box
          component='header'
          sx={{
            display: { xs: 'flex', md: 'none' },
            alignItems: 'center',
            gap: 1.5,
            px: 2,
            py: 1.25,
            borderBottom: '1px solid',
            borderColor: 'divider',
            backgroundColor: 'rgba(11, 14, 18, 0.85)',
            backdropFilter: 'blur(12px)',
            flexShrink: 0
          }}
        >
          <IconButton onClick={() => setMobileOpen(true)} aria-label='Open navigation'>
            <MenuOutlinedIcon />
          </IconButton>
          <Brand size={28} />
        </Box>

        <Box
          component='main'
          sx={{ flexGrow: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  )
}

export default AppLayout
